import { createContext } from "react";

export const ImageIdContext = createContext<number | undefined>(undefined);
